/*
  The Hush List page — behaviour.

  One instance per [data-hush-list] root. Reads the JSON the section
  renders (schedule, upcoming drop, any drop whose window is still
  running, copy, Klaviyo config) and derives the phase from the clock:
    wait     more than a day out: rubber stamp with the day count
    lastday  final day: flip clock, hours and minutes
    open     inside the window: flip clock counting down to close
    done     after a successful sign-up (remembers whether it was open)
  Review: ?hush_state=wait|lastday|open|done forces a phase; the Theme
  Editor select does the same inside the editor.

  Times are computed in the configured IANA zone (America/Los_Angeles)
  with a real offset lookup, so daylight saving is handled.

  Sign-up posts to Klaviyo's client subscription endpoint when a
  company id and list id are set; otherwise it is preview mode and
  nothing is sent.
*/
(function () {
  'use strict';

  var HOUR = 3600e3, DAY = 864e5;

  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function pad2(n) { n = Math.max(0, Math.floor(n)); return (n < 10 ? '0' : '') + n; }

  /* ── time zone helpers ── */
  function tzParts(ms, tz) {
    var dtf = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    var o = {};
    dtf.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
  }
  // Offset of tz at instant ms, in minutes east of UTC.
  function offsetAt(ms, tz) {
    var p = tzParts(ms, tz);
    var asUTC = Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s);
    return Math.round((asUTC - Math.floor(ms / 1000) * 1000) / 60000);
  }
  // Wall-clock y/m(0-based)/d h:mi in tz → Date. Two passes catch a DST edge.
  function zoned(y, m, d, h, mi, tz) {
    var guess = Date.UTC(y, m, d, h, mi);
    var t = guess - offsetAt(guess, tz) * 60000;
    var off2 = offsetAt(t, tz);
    var t2 = guess - off2 * 60000;
    return new Date(off2 === offsetAt(t2, tz) ? t2 : t);
  }
  function fmtDate(d, tz) {
    return new Intl.DateTimeFormat('en-US', { timeZone: tz, month: 'short', day: 'numeric' }).format(d);
  }
  function fmtTime(d, tz) {
    var p = tzParts(d.getTime(), tz);
    var opts = { timeZone: tz, hour: 'numeric' };
    if (p.mi) opts.minute = '2-digit';
    return new Intl.DateTimeFormat('en-US', opts).format(d).toLowerCase().replace(/\s+/g, '');
  }
  function sameDay(a, b, tz) {
    var pa = tzParts(a, tz), pb = tzParts(b, tz);
    return pa.y === pb.y && pa.m === pb.m && pa.d === pb.d;
  }

  function setup(root) {
    if (root.__hushList) return root.__hushList;
    var dataEl = root.querySelector('[data-hl-data]');
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var S = D.schedule || {}, C = D.copy || {}, TZ = S.tz || 'America/Los_Angeles';
    var WINDOW = (S.windowHours || 48) * HOUR, LASTDAY = (S.lastDayHours || 24) * HOUR;
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var state = { done: false, wasOpen: false, mode: 'phone', typed: false, busy: false };
    var inst = { root: root, state: state };

    /* ── review override ── */
    var forced = null;
    try {
      var q = new URLSearchParams(window.location.search).get('hush_state');
      if (/^(wait|lastday|open|done)$/.test(q || '')) forced = q;
    } catch (e) {}
    if (!forced && D.preview && D.preview !== 'auto') forced = D.preview;
    var forcedAt = Date.now();

    /* ── when does the next window open? ── */
    function scheduleOpen(now) {
      var p = tzParts(now, TZ);
      for (var k = -1; k <= 2; k++) {
        var open = zoned(p.y, p.m - 1 + k, S.day || 16, S.hour || 0, S.minute || 0, TZ);
        if (now < open.getTime() + WINDOW) return open;
      }
      return zoned(p.y, p.m, S.day || 16, S.hour || 0, S.minute || 0, TZ);
    }
    function times(now) {
      var open = null, n = D.next && D.next.n, type = D.next && D.next.type;
      // A drop whose product is already published and whose window is
      // running or ahead of us is the authority for its own number.
      (D.live || []).forEach(function (L) {
        if (!L.open) return;
        var o = L.open * 1000;
        if (now < o + WINDOW && (open === null || o < open)) { open = o; n = L.n || n; type = L.type || type; }
      });
      if (open === null && D.next && D.next.open) {
        var ov = Date.parse(D.next.open);
        if (!isNaN(ov) && now < ov + WINDOW) open = ov;
      }
      if (open === null) open = scheduleOpen(now).getTime();
      return { open: open, close: open + WINDOW, n: n, type: type };
    }

    function phaseFor(now, T) {
      if (state.done) return 'done';
      if (forced) return forced;
      if (now >= T.open && now < T.close) return 'open';
      if (T.open - now <= LASTDAY) return 'lastday';
      return 'wait';
    }

    /* ── render ── */
    var clock = $('[data-hl-clock]'), stamp = $('[data-hl-stamp]'), flip = $('[data-hl-flip]');
    var digits = $$('[data-hl-digit]');
    function setAll(sel, text) { $$(sel).forEach(function (e) { e.textContent = text; }); }

    function render() {
      var now = Date.now();
      var real = times(now), T = { open: real.open, close: real.close, n: real.n, type: real.type };
      // Forced phases get believable synthetic clocks; the printed
      // dates and times still come from the real schedule.
      if (forced === 'lastday') { T.open = forcedAt + 7 * HOUR + 42 * 60e3; T.close = T.open + WINDOW; }
      if (forced === 'open') { T.close = forcedAt + 31 * HOUR + 12 * 60e3; T.open = T.close - WINDOW; }
      var phase = phaseFor(now, T);
      var live = forced ? forced : (now >= T.open && now < T.close ? 'open' : (T.open - now <= LASTDAY ? 'lastday' : 'wait'));
      if (phase === 'done' && state.wasOpen) live = 'open';
      if (phase === 'done' && forced === 'done') live = 'wait';

      $$('[data-hl-phase]').forEach(function (el) {
        el.hidden = el.getAttribute('data-hl-phase').split(/\s+/).indexOf(phase) === -1;
      });

      var map = {
        date: fmtDate(new Date(real.open), TZ), time: fmtTime(new Date(real.open), TZ), tz: S.tzLabel || 'Pacific',
        closedate: fmtDate(new Date(real.close), TZ), closetime: fmtTime(new Date(real.close), TZ), hours: S.windowHours || 48, n: real.n
      };
      var showFlip = live === 'lastday' || live === 'open';
      if (stamp) stamp.hidden = showFlip;
      if (flip) flip.hidden = !showFlip;

      var label, sub, aria;
      if (live === 'open') {
        var leftMs = Math.max(0, T.close - now);
        label = C.clockCloses;
        var hh = Math.floor(leftMs / HOUR), mm = Math.floor((leftMs % HOUR) / 60e3);
        var str = pad2(hh) + pad2(mm);
        digits.forEach(function (d, i) { d.textContent = str.charAt(i); });
        sub = fill(C.subCloses, { date: map.closedate, time: map.closetime, tz: map.tz });
        aria = label + ' ' + pad2(hh) + ':' + pad2(mm);
      } else if (live === 'lastday') {
        var toMs = Math.max(0, T.open - now);
        label = C.clockNext;
        var h2 = Math.floor(toMs / HOUR), m2 = Math.floor((toMs % HOUR) / 60e3);
        var str2 = pad2(h2) + pad2(m2);
        digits.forEach(function (d, i) { d.textContent = str2.charAt(i); });
        sub = fill(forced === 'lastday' ? C.subTomorrow : (sameDay(now, real.open, TZ) ? C.subToday : C.subTomorrow), map);
        aria = label + ' ' + pad2(h2) + ':' + pad2(m2);
      } else {
        label = C.clockNext;
        var days = Math.max(1, Math.ceil((T.open - now) / DAY));
        var unit = days === 1 ? C.unitDay : C.unitDays;
        setAll('[data-hl-clock-big]', String(days));
        setAll('[data-hl-clock-unit]', unit);
        sub = fill(C.subOpens, map);
        aria = label + ' ' + days + ' ' + unit;
      }
      if (phase === 'done') {
        sub = fill(state.wasOpen ? C.subDoneOpen : C.subDoneWait, state.wasOpen ? { date: map.closedate, time: map.closetime, tz: map.tz, hours: map.hours } : map);
      }
      setAll('[data-hl-clock-label]', label);
      setAll('[data-hl-clock-sub]', sub);
      if (clock) clock.setAttribute('aria-label', aria + '. ' + sub);

      setAll('[data-hl-cta]', live === 'open' && !state.busy ? (C.ctaOpen || C.cta) : (state.busy ? (C.ctaBusy || C.cta) : C.cta));
      inst.phase = phase; inst.times = T;
    }

    /* ── redaction bars ── */
    $$('[data-hl-bar]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    });

    /* ── form ── */
    var form = $('[data-hl-form]');
    if (form) {
      var contact = $('[data-hl-contact]'), prefix = $('[data-hl-prefix]'), more = $('[data-hl-more]');
      var err = $('[data-hl-error]'), help = $('[data-hl-help]'), consent = $('[data-hl-consent]'), consentBox = $('[data-hl-consent-box]');
      var swap = $('[data-hl-swap]'), label = $('[data-hl-m="label"]'), ctas = $$('[data-hl-cta]');
      var inlineBtn = ctas[0], fullBtn = ctas[1];
      var MODES = {
        phone: { label: C.labelPhone, swap: C.swapToEmail, type: 'tel', mode: 'tel', ac: 'tel-national', ph: C.phPhone, help: C.helpPhone, err: C.errPhone, legal: true },
        email: { label: C.labelEmail, swap: C.swapToPhone, type: 'email', mode: 'email', ac: 'email', ph: C.phEmail, help: C.helpEmail, err: C.errEmail, legal: false }
      };
      function showError(msg) { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; if (contact) contact.setAttribute('aria-invalid', msg ? 'true' : 'false'); }
      function layout() {
        var m = MODES[state.mode], expanded = state.typed;
        if (more) more.hidden = !expanded;
        if (fullBtn) fullBtn.hidden = !expanded;
        if (inlineBtn) inlineBtn.hidden = expanded;
        if (consent) consent.hidden = !(expanded && m.legal);
      }
      function applyMode() {
        var m = MODES[state.mode];
        if (label) label.textContent = m.label;
        if (swap) swap.textContent = m.swap;
        if (contact) {
          contact.type = m.type; contact.setAttribute('inputmode', m.mode); contact.setAttribute('autocomplete', m.ac);
          contact.placeholder = m.ph || ''; contact.value = '';
        }
        if (prefix) prefix.hidden = !m.legal;
        if (help) help.textContent = m.help || '';
        state.typed = false; showError(''); layout();
      }
      if (swap) swap.addEventListener('click', function () { state.mode = state.mode === 'phone' ? 'email' : 'phone'; applyMode(); if (contact) contact.focus(); });
      if (contact) contact.addEventListener('input', function () {
        var was = state.typed; state.typed = contact.value.trim().length > 0; showError('');
        if (was !== state.typed) layout();
      });
      if (consentBox) consentBox.addEventListener('change', function () { showError(''); });

      function e164(v) {
        var d = v.replace(/\D/g, '');
        if (d.length === 10) return '+1' + d;
        if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
        if (/^\+/.test(v.trim()) && d.length >= 10 && d.length <= 15) return '+' + d;
        return null;
      }
      function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

      function send(payload) {
        var K = D.klaviyo || {};
        if (!K.companyId || !K.listId) {
          try { console.info('[hush-list] preview mode, nothing sent:', payload); } catch (e) {}
          return new Promise(function (res) { setTimeout(res, 600); });
        }
        var attrs = { properties: payload.properties, subscriptions: {} };
        if (payload.phone) { attrs.phone_number = payload.phone; attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
        if (payload.email) { attrs.email = payload.email; attrs.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } }; }
        if (payload.first) attrs.first_name = payload.first;
        if (payload.last) attrs.last_name = payload.last;
        var body = { data: { type: 'subscription', attributes: { custom_source: K.source || 'The Hush List page', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: K.listId } } } } };
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.companyId), {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': K.revision || '2024-10-15' }, body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (state.busy) return;
        var hp = $('[data-hl-hp]');
        var m = MODES[state.mode], v = contact ? contact.value.trim() : '';
        var payload = { properties: { hush_list_source: 'hush-list-page', drop_number: inst.times && inst.times.n, window_open: inst.phase === 'open' } };
        if (state.mode === 'phone') {
          var ph = e164(v);
          if (!ph) { showError(m.err); contact && contact.focus(); return; }
          if (!consentBox || !consentBox.checked) { showError(C.errConsent); consentBox && consentBox.focus(); return; }
          payload.phone = ph;
        } else {
          if (!validEmail(v)) { showError(m.err); contact && contact.focus(); return; }
          payload.email = v;
        }
        var f = $('[data-hl-first]'), l = $('[data-hl-last]'), s = $('[data-hl-sent]');
        if (f && f.value.trim()) payload.first = f.value.trim();
        if (l && l.value.trim()) payload.last = l.value.trim();
        if (s && s.value.trim()) payload.properties.who_sent_you = s.value.trim();
        var wasOpen = inst.phase === 'open';
        state.busy = true; ctas.forEach(function (b) { b.disabled = true; }); render();
        var p = (hp && hp.value) ? Promise.resolve() : send(payload);
        p.then(function () {
          state.busy = false; state.done = true; state.wasOpen = wasOpen; render();
          var h = root.querySelector('[data-hl-phase="done"] h1');
          if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        }).catch(function () {
          state.busy = false; ctas.forEach(function (b) { b.disabled = false; }); render(); showError(C.errSubmit);
        });
      });
      applyMode();
    }

    /* ── ledger ── */
    var ledger = $('[data-hl-ledger]');
    if (ledger) {
      var nowS = Date.now() / 1000;
      $$('.hl-row[data-close]').forEach(function (r) { if (+r.getAttribute('data-close') > nowS) r.hidden = true; });
      var moreBtn = $('[data-hl-more-btn]');
      if (moreBtn) moreBtn.addEventListener('click', function () {
        var rows = $$('.hl-row--more');
        rows.forEach(function (r) { if (!(+r.getAttribute('data-close') > nowS)) r.hidden = false; });
        moreBtn.hidden = true;
        var first = rows.filter(function (r) { return !r.hidden; })[0];
        if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); }
      });
      var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var peek = $('[data-hl-peek]'), peekImg = peek && peek.querySelector('img');
      if (fine && peek) {
        function place(e) {
          var b = ledger.getBoundingClientRect();
          peek.style.left = Math.min(e.clientX - b.left + 24, b.width - 190) + 'px';
          peek.style.top = (e.clientY - b.top - 90) + 'px';
        }
        $$('.hl-row[data-photo]').forEach(function (r) {
          r.addEventListener('mouseenter', function (e) { peekImg.src = r.getAttribute('data-photo'); place(e); peek.hidden = false; });
          r.addEventListener('mousemove', place);
          r.addEventListener('mouseleave', function () { peek.hidden = true; });
        });
      }
    }

    render();
    inst.timer = setInterval(render, 15000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
    root.__hushList = inst;
    return inst;
  }

  function init() { document.querySelectorAll('[data-hush-list]').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
